import { FC } from "react";
import { Box, Link, SimpleGrid } from "@chakra-ui/react";
import { motion } from "framer-motion";

import { ArticleTitle } from "pages/about/common/title/Title";
import { configs } from "shared/content/Content";
import { ContactPageId } from "utils/useScroll";
import { PageHeader } from "shared/page-header/PageHeader";
import ArticleCard from "shared/cards/Card";

// Create a motion wrapper for Chakra Box
const MotionBox = motion(Box);

export const Media: FC = () => {
    return (
        <>
            <Box id={ContactPageId}>
                <ArticleTitle title="" />
                <br />
                <PageHeader label="Articles" />

                <MotionBox
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <SimpleGrid columns={[1, 2, 3, 4]} spacing={6} p={6}>
                        {configs.about.articles.map((item, index) => (
                            <ArticleCard key={index} {...item} />
                        ))}
                    </SimpleGrid>
                </MotionBox>

                <PageHeader label="Media References" />

                <MotionBox
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <SimpleGrid columns={[1, 2, 3, 4]} spacing={6} p={6}>
                        {configs.about.media.map((item, index) => (
                            <ArticleCard key={index} {...item} />
                        ))}
                    </SimpleGrid>
                </MotionBox>
            </Box>
        </>
    );
};